import { gql } from "@apollo/client";
import { SHORT_FRAGMENT_SECTIONS } from "../../graphql/section.fragment";

export const instructorSection = gql`
  query instructorSection(
    $scenarioId: ID!
    $originId: ID!
    $resourceType: ResourceType!
    $resourceId: ID!
  ) {
    base {
      customFields(resourceType: $resourceType) {
        id
        code
        name
        label
      }
    }
    cube(scenarioId: $scenarioId, originId: $originId) {
      editorView(resourceType: $resourceType, resourceId: $resourceId) {
        info {
          __typename
          ... on InstructorInfo {
            instructor {
              id
              code
              name
              contract
              priority
              minBlocks
              maxBlocks
              maxSections
              maxCourseComponents
              minCourses
              hasAccess
              contractType {
                id
                code
                name
              }
              assignment {
                currentYearBlocks
                nextYearBlocks
                totalAssignedBlocks
                totalAssignedBlocksWithBTR
                totalRemainingBlocks
                totalRemainingBlocksCurrentYear
                totalRemainingBlocksNextYear
              }
              customFields {
                id
                value
                code
              }
            }
            assignedBlocks
            assignedSections
            assignedCourses
          }
        }
        ...CalendarSections
      }
      editorWeeks(resourceType: $resourceType, resourceId: $resourceId) {
        id
        name
        startingDate
        endingDate
        eventCount
      }
      editorRestrictions(resourceType: $resourceType, resourceId: $resourceId) {
        type
        scheduleEvent {
          id
          dayId
          start
          end
        }
      }
    }
  }
  ${SHORT_FRAGMENT_SECTIONS}
`;
